import { render } from "./AulasExperimentaisSemana.vue?vue&type=template&id=31c9a5ae&scoped=true"
import script from "./AulasExperimentaisSemana.vue?vue&type=script&lang=js"
export * from "./AulasExperimentaisSemana.vue?vue&type=script&lang=js"

import "./AulasExperimentaisSemana.vue?vue&type=style&index=0&id=31c9a5ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c9a5ae"]])

export default __exports__